"use client";

import { useState, useEffect } from "react";
import { Star } from "lucide-react";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { cn } from "@/lib/utils";

import { Card } from "@/components/ui/card";

interface DataItem {
  name: string;
  avatar: string;
  content: string;
  margin?: string;
}

const DATA: DataItem[] = [
  {
    name: "Miguel",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-1.webp",
    content:
      "Mi experiencia ha sido espectacular. El trato recibido por Laura es inmejorable. Mi piso tenía muchas complicaciones para la venta pero Laura las salvó todas he hizo fácil lo difícil. Estoy muy agradecido por el trabajo realizado y a nivel personal encantado con Laura, que es muy buena a nivel profesional y personal. Sin duda doy el máximo de puntuación y es bien merecida",
    margin: "mt-6",
  },
  {
    name: "Manuel",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-2.webp",
    content:
      "Una experiancia muy grata, sobre todo con el agente que nos acompañó en todo momento. El agente en cuestión se llama Manuel y gracias a él y a su entusiasmo conseguimos la vivienda en un tiempo record, por motivos personales necesitábamos una vivienda urgentemente y aunque en esta situación internvienen muchos factores (bancos, estudios de préstamos, inmobiliaria, vendedores, etc...) Manuel se volcó con nosotros y se encargó de todo para conseguirlo, todo el proceso se hizo en menos de un mes y por el medio habían muchos papeles que pedir y presentar. Ahora que ya han pasado varios días desde la venta y pensándolo más tranquilo valoro aún más el trabajo de este chico. Gracias Manuel.",
  },
  {
    name: "Paula",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-3.webp",
    content:
      "Encontramos nuestro nuevo hogar a través de Person y estamos encantados. Manuel fue extremadamente cálido, amable y profesional durante todo el proceso, lo cual hizo que una experiencia normalmente estresante fuera muy amena. Estamos enormemente agradecidos.",
    margin: "mt-4",
  },
  {
    name: "Angela",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-4.webp",
    content:
      "Alexandra nos ha acompañado en el proceso con nuestro inmueble. Seguimos trabajando con ella. Es muy buena profesional y atenta. Escucha lo que necesitamos y es un gran apoyo. Estamos encantadas con ella. 5 Estrellas se queda corto.",
  },
  {
    name: "Simone",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-5.webp",
    content:
      "Mi experiencia con Alexandra fue genial! Se tomó el tiempo para explicar todo y facilitó todas las etapas del proceso de alquiler con un alto grado de profesionalismo. Muchas gracias!",
  },
  {
    name: "Boris",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-6.webp",
    content:
      "El trato y profesionalidad que me demostró la señorita Priscila fue de 10, agradezco todos los consejos y gran atención que me ha dado siempre desde el primer momento, la recomiendo mucho.",
  },
  {
    name: "Andrés",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-7.webp",
    content:
      "Todo genial con Manuel. Una experiencia estupenda desde la primera visita hasta la firma con el notario. Siempre muy atento para resolver cualquier duda y siempre revisando todos los aspectos legales para evitar problemas. Son unos auténticos profesionales y, sobre todo, muy cercanos, tanto con el comprador como con el vendedor, para que la operación sea totalmente transparente. ¡¡Ha sido un placer!! Totalmente recomendable.",
  },
  {
    name: "Angela",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-8.webp",
    content:
      "Alexandra nos ha acompañado en el proceso con nuestro inmueble. Seguimos trabajando con ella. Es muy buena profesional y atenta. Escucha lo que necesitamos y es un gran apoyo. Estamos encantadas con ella. 5 Estrellas se queda corto",
  },
  {
    name: "Yola",
    avatar: "https://deifkwefumgah.cloudfront.net/shadcnblocks/block/avatar-4.webp",
    content:
      "Muy contenta con los servicios de esta agencia, en especial del agente Carlos Martínez. Atento, rápido, efectivo, y servicial. Cualquier cosa que surja siempre está dispuesto a ayudar y a cualquier hora. Recomiendo esta agencia y a Carlos un 100%.",
  },
];

interface Testimonial24Props {
  backgroundColor?: string;
}

const Testimonial24 = ({ backgroundColor = "#FFFFFF" }: Testimonial24Props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return (
      <section className="overflow-x-hidden py-32" style={{ backgroundColor }}>
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Title */}
          <div className="flex flex-col items-center gap-2">
          <p className="text-center text-muted-foreground ">Nuestros clientes</p>
          <h2 className="text-center text-3xl font-normal lg:text-2xl">
            Lo que dicen de nosotros
          </h2>
        </div>

          <div className="relative mt-14 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {DATA.map((testimonial, idx) => (
                <Card
                  key={idx}
                  className={cn(
                    "rounded-xl p-9 shadow-sm",
                    idx > 3 && idx <= 5 && "hidden md:block",
                    idx > 5 && "hidden lg:block",
                    testimonial.margin,
                  )}
                >
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-4 w-4" style={{ fill: "#193144", color: "#193144" }} />
                    ))}
                  </div>

                  <div className="text-foreground text-sm">
                    <q>{testimonial.content}</q>
                  </div>

                  <div className="mt-4">
                    <p className="text-sm">{testimonial.name}</p>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="overflow-x-hidden py-32" style={{ backgroundColor }}>
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="flex flex-col items-center gap-2">
          <p className="text-center text-muted-foreground ">Nuestros clientes</p>
          <h2 className="text-center text-3xl font-normal lg:text-2xl">
            Lo que dicen de nosotros
          </h2>
        </div>

        <div className="relative mt-14 w-full">
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 768: 2, 1024: 3 }}
          >
            <Masonry gutter="20px" columnsCount={3}>
              {DATA.map((testimonial, idx) => (
                <Card
                  key={idx}
                  className={cn(
                    "rounded-xl p-9 shadow-sm",
                    idx > 3 && idx <= 5 && "hidden md:block",
                    idx > 5 && "hidden lg:block",
                    testimonial.margin,
                  )}
                >
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-4 w-4" style={{ fill: "#193144", color: "#193144" }} />
                    ))}
                  </div>

                  <div className="text-black mt-4 text-sm leading-relaxed">
                    <q>{testimonial.content}</q>
                  </div>

                  <div className="mt-4">
                    <p className="text-sm">{testimonial.name}</p>
                  </div>
                </Card>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
    </section>
  );
};

export { Testimonial24 };

